export default {
  install: (Vue, options) => {
    Vue.prototype.$roleutility = {
      checkpermission: async function (pagename, pageid) {
        // var permissionstatus = false
        var pagepermission = { insertable: false, editable: false, viewable: false, deletable: false }
        // var pagepermissions = []
        var srSchoolRoles = []
        // check role
        let userrole = JSON.parse(localStorage.getItem('user'))
        let schoolroles = userrole.school_roles
        // let submodules = userrole.sub_modules

        if (userrole.role === 'admin') {
          pagepermission.editable = true
          pagepermission.insertable = true
          pagepermission.viewable = true
          pagepermission.deletable = true
          pagepermission.candeclare = true
          pagepermission.canundeclare = true
          pagepermission.resultviewable = true
          pagepermission.canexport = true
          pagepermission.cancreatequestion = true
          pagepermission.caneditquestion = true
          pagepermission.canviewquestion = true
          pagepermission.candeletequestion = true
          //   permissionstatus = true
          return { permissionStatus: true, isAdmin: true, pagePermission: pagepermission }
        } else {
          try {
            // get all role id from user school roles
            srSchoolRoles = []
            srSchoolRoles.length = 0
            schoolroles.forEach(_role => {
              srSchoolRoles.push(_role.id)
            })
            console.log('server prep [school_roles_id]', srSchoolRoles)
            // end get role
            // let thismodule = submodules.find(o => o.identifier === pagename)
            // console.log('thismodule')
            // console.log(thismodule)
            // let permissionsforthismodule = schoolroles.some(o => o.sub_module_id === thismodule.id)
            // console.log('permission for this module')
            // console.log(permissionsforthismodule)
            // // await Promise.all(schoolroles.map(async (r) => {
            // //   const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/school-role-permissions?school_role_id=${r.id}`)
            // //   if (!response.ok) {
            // //     throw new Error(`HTTP Error: ${response.status}`)
            // //   }
            // //   const data = await response.json()
            // //   data.forEach(_d => {
            // //     pagepermissions.push(_d)
            // //     console.log('pushing')
            // //     console.log(pagepermissions)
            // //   })
            // // }))
            // console.log(`${process.env.VUE_APP_SERVER_URL}/api/module-permissions?module_id=&sub_module_id=${thismodule.id}`)
            // fetch(`${process.env.VUE_APP_SERVER_URL}/api/module-permissions?module_id=&sub_module_id=${thismodule.id}`)
            //   .then(response => response.json())
            //   .then((data) => {
            //     tpermissions = data.data
            //     console.log('tpermission', data.data)
            //   })
            // console.log('tperission', tpermissions)
            console.log('JSON', JSON.stringify(srSchoolRoles))
            const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/school-role-permissions`, {
              method: 'POST',
              mode: 'cors',
              body: `{ "school_role_ids": ${JSON.stringify(srSchoolRoles)} }`,
              headers: { 'content-type': 'application/json' },
            })
            if (!response.ok) {
              throw new Error(`HTTP Error: ${response.status}`)
            }
            const data = await response.json()
            console.log('return data from server ', data)
            if (data.data.length > 0) {
              let section = pagename
              let permissions = data.data
              // console.log('permissions')
              // console.log(permissions)
              // exam-mark-update
              if (pagename === 'exam-mark-update') {
                pagepermission.insertable = permissions.some(item => item.slug === `${section}-create`)
                pagepermission.editable = permissions.some(item => item.slug === pagename)
                pagepermission.viewable = permissions.some(item => item.slug === `${section}-view`)
                pagepermission.deletable = permissions.some(item => item.slug === `${section}-delete`)
                return { permissionStatus: true, isAdmin: false, pagePermission: pagepermission }
              }
              // end exam-mark-update
              if (pagename === 'online-exam') {
                pagepermission.insertable = permissions.some(item => item.slug === `${section}-create`)
                pagepermission.editable = permissions.some(item => item.slug === `${section}-edit`)
                pagepermission.viewable = permissions.some(item => item.slug === `${section}-view`)
                pagepermission.deletable = permissions.some(item => item.slug === `${section}-delete`)
                pagepermission.candeclare = permissions.some(item => item.slug === `${section}-declare`)
                pagepermission.canundeclare = permissions.some(item => item.slug === `${section}-undeclare`)
                pagepermission.resultviewable = permissions.some(item => item.slug === `${section}-view-result`)
                pagepermission.canexport = permissions.some(item => item.slug === `${section}-result-export`)
                pagepermission.cancreatequestion = permissions.some(item => item.slug === 'oe-question-create')
                pagepermission.caneditquestion = permissions.some(item => item.slug === 'oe-question-edit')
                pagepermission.canviewquestion = permissions.some(item => item.slug === 'oe-question-view')
                pagepermission.candeletequestion = permissions.some(item => item.slug === 'oe-question-delete')
                return { permissionStatus: true, isAdmin: false, pagePermission: pagepermission }
              }
              pagepermission.insertable = permissions.some(item => item.slug === `${section}-create`)
              pagepermission.editable = permissions.some(item => item.slug === `${section}-edit`)
              pagepermission.viewable = permissions.some(item => item.slug === `${section}-view`)
              pagepermission.deletable = permissions.some(item => item.slug === `${section}-delete`)
              return { permissionStatus: true, isAdmin: false, pagePermission: pagepermission }
            } else {
              return { permissionStatus: false, isAdmin: false, pagePermission: pagepermission }
            }
          } catch (error) {
            console.debug('error occured.', error)
            return { permissionStatus: false, isAdmin: false, pagePermission: pagepermission }
          }
        }
      },
    }
  },
}
